function animated_slider(selector, speed = 0.4, direction = 'ltr') {
    let flickity = null;
    let isPaused = false;
    const slideshowEl = document.querySelector(selector);

    const update = () => {
        if (isPaused) return;
        if (flickity.slides) {
            if (direction === 'ltr') {
                flickity.x = (flickity.x + speed) % flickity.slideableWidth;
            } else {
                flickity.x = (flickity.x - speed) % flickity.slideableWidth;
            }

            flickity.selectedIndex = flickity.dragEndRestingSelect();
            flickity.updateSelectedSlide();
            flickity.settle(flickity.x);
        }
        window.requestAnimationFrame(update);
    };

    const pause = () => {
        isPaused = true;
    };

    const play = () => {
        if (isPaused) {
            isPaused = false;
            window.requestAnimationFrame(update);
        }
    };

    flickity = new Flickity(slideshowEl, {
        autoPlay: false,
        prevNextButtons: false,
        pageDots: false,
        draggable: true,
        wrapAround: true,
        selectedAttraction: 0.015,
        friction: 0.25
    });
    flickity.x = 0;

    slideshowEl.addEventListener('mouseenter', pause, false);
    slideshowEl.addEventListener('focusin', pause, false);
    slideshowEl.addEventListener('mouseleave', play, false);
    slideshowEl.addEventListener('focusout', play, false);

    flickity.on('dragStart', () => {
        isPaused = true;
    });
    update();
}

animated_slider('.infinite-carousel', .4, 'ltr');